import { ColumnList } from "components/ColumnList"
import { ColumnListColumn } from "components/ColumnList/types"

import { DisplayPrices, Order } from "../types"

const columns: ColumnListColumn[] = [
    { header: '', accessor: 'name', align: 'left' },
    { header: '', accessor: 'value', align: 'right' },
]

export const Discount = ({ order, displayPrices }: { order?: Order, displayPrices: DisplayPrices | null }) => {
    if (!order || !displayPrices) return null;
    if (order.discountAmount === 0) return null;

    return (
        <div className="flex flex-col gap-4 p-6 pb-8 border border-base-sidebarBorder rounded-lg">
            <h2 className="font-medium text-xl text-base-primary">Discounts</h2>
            <div className="flex flex-col gap-4">
                <ColumnList columns={columns} data={[
                    { name: 'Promo Code', value: order.promoCodeName || 'N/A' },
                    { name: 'Discount Amount', value: `${order.currencySymbol}${Math.abs(displayPrices.discountAmount).toFixed(2)}` },
                    { name: 'Discount Rate', value: `${order.discountRatePoints}%` },
                ]} />
            </div>
        </div>
    )
}